import { Typography, styled } from '@mui/material'
import { formatAmount, formatDayMonthYear } from '@/utils/common'
import { MaskedNumber } from '@/components/UI/MaskedNumber'
import { ITransaction } from '@/types'
import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { aliasLabel } from './aliasOptions'

export const transactionColumns: ITableColumn<ITransaction>[] = [
  {
    key: 'transactionDate',
    id: 'transactionDate',
    minWidth: '150px',
    label: 'Date',
    enableSorting: true,
    render: (value = '') => <StyledText>{formatDayMonthYear(value)}</StyledText>,
  },
  {
    key: 'accountNumber',
    id: 'accountNumber',
    minWidth: '150px',
    label: 'Account',
    enableSorting: true,
    align: 'right',
    render: (value = '') => (
      <StyledText>
        <MaskedNumber value={value} />
      </StyledText>
    ),
  },
  {
    key: 'amount',
    id: 'amount',
    minWidth: '120px',
    label: 'Amount',
    enableSorting: true,
    align: 'right',
    render: (value = 0) => <StyledText>{formatAmount(value)}</StyledText>,
  },
  {
    key: 'description',
    id: 'description',
    minWidth: '300px',
    label: 'Description',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
  {
    key: 'descriptionAlias',
    id: 'descriptionAlias',
    minWidth: '150px',
    label: 'Description Alias',
    enableSorting: true,
    render: (value = '') => <StyledText>{aliasLabel(value)}</StyledText>,
  },
  {
    key: 'accountClass',
    id: 'accountClass',
    minWidth: '150px',
    label: 'Class Type',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
  {
    key: 'status',
    id: 'status',
    minWidth: '120px',
    label: 'Status',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
  {
    key: 'institutionName',
    id: 'institutionName',
    minWidth: '180px',
    label: 'Institution Name',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
  {
    key: 'name',
    id: 'name',
    minWidth: '180px',
    label: 'Account Name',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },

  {
    key: 'accountProduct',
    id: 'accountProduct',
    minWidth: '180px',
    label: 'Product Type',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
  {
    key: 'accountId',
    id: 'accountId',
    minWidth: '350px',
    label: 'Account ID',
    enableSorting: true,
    render: (value = '') => <StyledText>{value}</StyledText>,
  },
]

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'inherit',
  color: theme.palette.secondary.main,
}))
